module.exports = __webpack_public_path__ + "static/img/dzbapp_android.61fe80f6.png";